import { Component, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { ListComponent } from '../list/list.component';

@Component({
    selector: 'app-stock-transfer',
    templateUrl: './stock-transfer.component.html',
    styleUrls: ['./stock-transfer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StockTransferComponent {

  @ViewChild(ListComponent) listComponent: ListComponent;
}
